import { API } from "aws-amplify";
import { OffLineAPI } from "../offline-auth/api";

var _API = process.env.REACT_APP_isOffline === "true" ? OffLineAPI : API;
///////here inClinicLicense leads to inclinic license api only
export const createOrder = (body) => {
    return new Promise((resolve, reject) => {
        _API.post("inClinicLicense", `/createorder`, { body })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const applyCoupon = (code, productCode) => {
    return _API.get("users", `/applycoupon/${code}?product=${productCode}`);
};

export const getCouponDetails = (query) => {
    return new Promise((resolve, reject) => {
        _API.get("inaffiliateUser", `/getCoupon/${query}`)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
    // return _API.get("inaffiliateUserAPI", `/getCoupon/${query}`);
};

export const capturePayment = (body) => {
    return new Promise((resolve, reject) => {
        _API.post("inClinicLicense", `/capturepayment`, { body })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getMyLicense = () => {
    return new Promise((resolve, reject) => {
        _API.get("inClinicLicense", `/getmylicense`)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const createFreeOrder = (body) => {
    return new Promise((resolve, reject) => {
        _API.post("admin", "/freelicense", { body })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
